import BookingPathReviewBookingCTA from './BookingPathReviewBookingCTA';

export default BookingPathReviewBookingCTA;
